import React from 'react';
import type { HomeProps } from '../../../shells/types';

const STORIES = [
  { id: 'add',   glyph: '+',  label: 'add'   },
  { id: 'you',   glyph: '✨', label: 'you'   },
  { id: 'jules', glyph: '🦊', label: 'jules' },
  { id: 'kai',   glyph: '🐙', label: 'kai'   },
  { id: 'river', glyph: '🦄', label: 'river' },
  { id: 'leah',  glyph: '🌸', label: 'leah'  },
];

const FRIENDS = [
  { name: 'jules', status: '🎮 in a match'  },
  { name: 'kai',   status: '📚 studying'    },
  { name: 'river', status: '🚶 walking home' },
  { name: 'sam',   status: '🌙 idle 20m'    },
];

/**
 * Phase 73 full — Teens A · Vibes Home surface.
 *
 * Dark-mode social-first home with stories carousel, drop button, and
 * friends grid. Reskin — every action bridges into existing surfaces
 * (stories → social-stories, drop → social-compose, friend chip →
 * sass-chats, SOS → env-intake).
 */
export function VibesHome({ ctx }: HomeProps): JSX.Element {
  const go = (target: string, reason: string) => {
    ctx.director.bridge(target, reason);
  };

  return (
    <div className="vibes-home" data-testid="vibes-home">
      <div className="vibes-header">
        <span className="vibes-name">vibes</span>
        <button type="button" className="vibes-sos" data-testid="vibes-sos" onClick={() => go('env-intake', 'vibes-sos')}>
          SOS · grown-up
        </button>
      </div>

      <div className="vibes-stories" role="tablist" aria-label="stories">
        {STORIES.map((s) => (
          <button
            key={s.id}
            type="button"
            className="vibes-story"
            data-testid={`vibes-story-${s.id}`}
            onClick={() => go(s.id === 'add' ? 'social-compose' : 'social-stories', `vibes-story-${s.id}`)}
          >
            <span className="vibes-story-ring"><span className="vibes-story-ring-inner" aria-hidden>{s.glyph}</span></span>
            <span className="vibes-story-label">{s.label}</span>
          </button>
        ))}
      </div>

      <button
        type="button"
        className="vibes-drop"
        data-testid="vibes-drop"
        onClick={() => go('social-compose', 'vibes-drop')}
      >
        <span className="vibes-drop-glyph" aria-hidden>✨</span>
        <span className="vibes-drop-text">
          <span className="vibes-drop-title">Drop something</span>
          <span className="vibes-drop-sub">post · story · voice · poll</span>
        </span>
      </button>

      <div className="vibes-section">
        <span className="vibes-section-title">friends now</span>
        <div className="vibes-friends">
          {FRIENDS.map((f) => (
            <button
              key={f.name}
              type="button"
              className="vibes-friend"
              data-testid={`vibes-friend-${f.name}`}
              onClick={() => go('contact-picker', `vibes-friend-${f.name}`)}
            >
              <span className="vibes-friend-name">{f.name}</span>
              <span className="vibes-friend-status">{f.status}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
